import { useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { bindActionCreators } from "redux";
import {
  trunkGetDiskSpace,
  trunkGetCreatedWorkgroupCnt,
  trunkGetSharedDocCnt,
  trunkGetPageLicense,
  trunkGetMemberCnt,
  trunkGetLineChart,
  trunkGetTopMemberWorkgroup,
  trunkGetTopDoc,
  trunkDownloadChart,
} from "../store/admin/adminHome";

const useAdminDeptStore = () => {
  const adminHomeStore = useRootState((state) => state.adminHomeStore);

  const dispatch = useAppDispatch();

  const boundGetDiskSpace = useMemo(
    () => bindActionCreators(trunkGetDiskSpace, dispatch),
    [dispatch]
  );

  const boundGetCreatedWorkgroupCnt = useMemo(
    () => bindActionCreators(trunkGetCreatedWorkgroupCnt, dispatch),
    [dispatch]
  );

  const boundGetSharedDocCnt = useMemo(
    () => bindActionCreators(trunkGetSharedDocCnt, dispatch),
    [dispatch]
  );

  const boundGetPageLicense = useMemo(
    () => bindActionCreators(trunkGetPageLicense, dispatch),
    [dispatch]
  );

  const boundGetMemberCnt = useMemo(
    () => bindActionCreators(trunkGetMemberCnt, dispatch),
    [dispatch]
  );

  const boundGetLineChart = useMemo(
    () => bindActionCreators(trunkGetLineChart, dispatch),
    [dispatch]
  );

  const boundGetTopMemberWorkgroup = useMemo(
    () => bindActionCreators(trunkGetTopMemberWorkgroup, dispatch),
    [dispatch]
  );

  const boundGetTopDoc = useMemo(
    () => bindActionCreators(trunkGetTopDoc, dispatch),
    [dispatch]
  );

  const boundDownloadChart = useMemo(
    () => bindActionCreators(trunkDownloadChart, dispatch),
    [dispatch]
  );

  return {
    adminHomeStore,
    getDiskSpace: boundGetDiskSpace,
    getCreatedWorkgroupCnt: boundGetCreatedWorkgroupCnt,
    getSharedDocCnt: boundGetSharedDocCnt,
    getPageLicense: boundGetPageLicense,
    getMemberCnt: boundGetMemberCnt,
    getLineChart: boundGetLineChart,
    getTopMemberWorkgroup: boundGetTopMemberWorkgroup,
    getTopDoc: boundGetTopDoc,
    downloadChart: boundDownloadChart,
  };
};

export default useAdminDeptStore;
